module.exports = __webpack_public_path__ + "static/mid_text-46b3d2cb81864857c9a127d25ff050d5.png";